import type { ApiEmbedSearchWidgetId } from '#/api/types/ApiTypedId';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import { embedSearchWidgetViewVolopPath } from '#/modules/embedSearchWidget/volops/routing/embedSearchWidgetVolops.paths';
import { importedEventPath } from '#/modules/listing/routing/listing.paths';
import type { SearchAlgoliaHit } from '#/modules/search/algolia/types/SearchAlgoliaHit';

type Args = {
  result: SearchAlgoliaHit;
  embedSearchWidgetId: ApiEmbedSearchWidgetId | null;
  locale: I18nLocale;
};

export function searchContextHeaderGetUrl({
  result,
  embedSearchWidgetId,
  locale,
}: Args) {
  if (embedSearchWidgetId) {
    return embedSearchWidgetViewVolopPath.with({
      lang: locale,
      embedSearchWidgetId,
      volopId: result.objectID,
    });
  }

  if (result.type === 'IMPORTED') {
    return importedEventPath.with({
      lang: locale,
      source: result.source.toLowerCase(),
      eventId: result.objectID.replace(`${result.source}_`, ''),
    });
  }

  if (typeof result.url === 'string') return result.url;

  return result.url[locale];
}
